import {useContext, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import MediaContext from "../../context/MediaContext";
import {getTestToneLevel} from "../../helper/testTone";
import Visualization from "./Visualization";

const SAMPLE_MS = 50
// The microphone bar's scale, and not redundant: it cancels out of the fill, but not out of
// `Visualization`'s `value < .1` floor — the bar rests at a 1% sliver here, 10% under `max={1}`.
const SCALE = 10

export default () => {
    const {speakerTesting, speakerTestEl} = useContext(MediaContext)
    const {t} = useTranslation()
    const [level, setLevel] = useState(0)
    const levelRef = useRef(0)

    // The tone's own envelope read off `currentTime`, never the element through an analyser: routing
    // it into an AudioContext takes setSinkId out of the path this test exists to prove
    // (RISKS.md/P2.54). It shows what the page is emitting, which is not proof anything is audible.
    useEffect(() => {
        if (!speakerTesting) {
            levelRef.current = 0
            setLevel(0)
            return
        }
        const sample = () => {
            const el = speakerTestEl.current
            const next = el && !el.paused ? getTestToneLevel(el.currentTime) : 0
            if (next === levelRef.current) return
            levelRef.current = next
            setLevel(next)
        }
        const interval = setInterval(sample, SAMPLE_MS)
        return () => clearInterval(interval)
    }, [speakerTesting, speakerTestEl])

    return (
        <div className="level-meter" role="img" aria-label={t('lobby.speakerLevel')}>
            <Visualization max={SCALE} value={level * SCALE}/>
        </div>
    )
}
